import React from 'react';
import Home from './Home';

export default () => {
  return <Home />;
};
